import { useState } from 'react';

export const useIsVisible = ({ initialIsOpen = false }: { initialIsOpen?: boolean; } = {}) => {
    const [isOpen, setIsOpen] = useState(initialIsOpen);
    const onClose = () => setIsOpen(false);
    const onShow = () => setIsOpen(true);
    const onToggle = (forceState?: boolean) => setIsOpen(p => forceState ?? !p);

    return {
        isOpen,
        onClose,
        onShow,
        onToggle,
    };
};